// extracted by mini-css-extract-plugin
export default {"analyticsBox":"xaeJa8EIex_M0d2gQj98","separator":"IaPfG9COrANcsijTzfC1"};